import { CarrouselProps } from "./interfaces/Carrousel";

export const DEFAULT_DATA: CarrouselProps = {
  time: "10",
  title: { value: "Medicamentos" },
  alling: "CENTER",
  items: [
    {
      id: "672fbdd4-9460-1db2-d083-e8f1e75baf52",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/f9f12c2a-296a-41ee-8090-c750790daa7f.webp",
      },
      description: {
        value:
          "Mirrapel es un suplemento nutricional en polvo de suministro diario y oral para mascotas. Su fórmula contiene ingredientes y nutrientes de calidad que favorecerán la salud de tu mascota, ayudándolo a mantenerse saludable y vital por más tiempo.",
      },
    },
    {
      id: "ec46a98b-2b1f-d29d-4be7-b2b3bf99e3c7",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/5800b14c-4fb9-44e7-a849-f842c2b97522.webp",
      },
      description: {
        value:
          "Mirrapel es un suplemento nutricional en polvo de suministro diario y oral para mascotas. Su fórmula contiene ingredientes y nutrientes de calidad que favorecerán la salud de tu mascota, ayudándolo a mantenerse saludable y vital por más tiempo.",
      },
    },
    {
      id: "ba14d2d2-5752-f414-b49a-360a3960075b",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/07101bcb-7519-4bdd-8890-4656e404f043.webp",
      },
      description: {
        value:
          "Mirrapel es un suplemento nutricional en polvo de suministro diario y oral para mascotas. Su fórmula contiene ingredientes y nutrientes de calidad que favorecerán la salud de tu mascota, ayudándolo a mantenerse saludable y vital por más tiempo.",
      },
    },
    {
      id: "5e0e23bf-84e9-337f-3ae7-562de8faab65",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/5c0c9398-67f4-48fb-937d-58662e561ee4.webp",
      },
      description: {
        value:
          "Restituye la afectividad, la tolerancia, la calma, la espontaneidad, el autocontrol y la flexibilidad en los animales. Indicado para perros de temperamento difícil, intolerantes o dominantes",
      },
    },
  ],
  total: "3",
};
